export const apiConfig = {
  API_URL: process.env.REACT_APP_API_URL || `https://api.invitation-codes-dev.awsvintagenp.manheim.com/v1`,
};
